import { atom, selector } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

const selectedOnfCategoriesState = atom({
  key: 'selectedOnfCategories',
  default: {
    streetCategory: ['Transit Corridors', 'Urban Connectors', 'City Hubs', 'Activity Streets', 'Main Streets', 'Local Streets', 'Civic Spaces', 'Interregional Connectors', 'Stopping Places', 'Rural Connectors', 'Peri-urban Roads', 'Rural Roads'],
    generalTraffic: ['GT1', 'GT2', 'GT3', 'GT4', 'GT5', 'GT6', 'GT7', 'GT8'],
    freight: ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8'],
  },
  effects_UNSTABLE: [persistAtom],
});

const selectedOnfCategoryTypeState = atom({
  key: 'selectedOnfCategoryType',
  default: 'all',
  effects_UNSTABLE: [persistAtom],
});

const selectedGroupState = atom({
  key: 'selectedOnfCategoryGroup',
  default: 'streetCategory',
  effects_UNSTABLE: [persistAtom],
});

const selectedOnfStreetFamilyState = atom({
  key: 'selectedOnfStreetFamily',
  default: 'B',
  effects_UNSTABLE: [persistAtom],
});

const isComparativeReportState = atom({
  key: 'isComparativeReportState',
  default: false,
});

const selectedCategoriesForGroupSelector = selector({
  key: 'selectedCategoriesForGroup',
  get: ({ get }) => {
    const group = get(selectedGroupState);
    const categories = get(selectedOnfCategoriesState);

    return categories[group] ?? [];
  },
});

export {
  selectedOnfCategoriesState,
  selectedOnfStreetFamilyState,
  selectedGroupState,
  selectedOnfCategoryTypeState,
  isComparativeReportState,
  selectedCategoriesForGroupSelector,
};
